module.exports = __webpack_public_path__ + "img/pic-24.86b6db47.png";